"use client"

import { Skeleton } from "@/components/ui/skeleton"

const SidePostsSkeleton = () => {
  return (
    <div className="flex flex-col w-full">
      {Array.from({ length: 5 }).map((_, idx) => (
        <div key={idx}>
          <div className="flex flex-col gap-1">
            <Skeleton className="h-3 w-16 rounded" />
            <Skeleton className="h-5 w-full rounded" />
          </div>
          {idx < 4 && <div className="border-t border-dashed border-[#00000033] sm:my-5 my-2.5"></div>}
        </div>
      ))}
    </div>
  )
}

export default SidePostsSkeleton
